import React, { useMemo } from 'react';
import BellIcon from 'icons/Bell.icon';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import {
  DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION,
  DataRoomNdaSigningTimelineAction,
} from 'router/subrouters/DataRoom/models/DataRoomNDA';
import useSendSignerReminder from '../../hooks';

const useGenerateTimelineActions = (
  signingId: string,
  onSendReminder: (signingId: string) => void,
) => {
  const { t } = useTranslation();

  const { isLoading, sendReminder } = useSendSignerReminder(
    signingId,
    onSendReminder,
  );

  const RemindButton = useMemo(
    () => (
      <Button
        variant="link"
        className="timeline-action"
        icon={BellIcon}
        disabled={isLoading}
        onClick={sendReminder}
      >
        {t('sendReminder')}
      </Button>
    ),
    [isLoading, sendReminder, t],
  );

  const ndaTimelineActions: Partial<
    Record<DataRoomNdaSigningTimelineAction, JSX.Element>
  > = useMemo(
    () => ({
      [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.SENT]: RemindButton,
      [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.REMINDER]: RemindButton,
      [DATA_ROOM_NDA_SIGNING_TIMELINE_ACTION.MANUALLY_UPDATED]: RemindButton,
    }),
    [RemindButton],
  );

  return ndaTimelineActions;
};

export default useGenerateTimelineActions;
